export interface ViaticoItem {
  date: string
  supplier: string
  ruc?: string
  documentType: string
  documentNumber: string
  detail?: string
  taxableAmount?: number
  taxAmount?: number
  amount: number
  currency?: string
  imageUrl?: string
}

export const VIATICO_SECTIONS = ["movilizacion", "alimentacion", "hospedaje", "varios"] as const
export type ViaticoSection = (typeof VIATICO_SECTIONS)[number]

export const VIATICO_SECTION_LABELS: Record<ViaticoSection, string> = {
  movilizacion: "Movilidad",
  alimentacion: "Alimentación",
  hospedaje: "Hospedaje",
  varios: "Varios"
}

export interface ViaticoSectionAccounting {
  costCenter?: string
  accountingEntry?: string
  observations?: string
}

export type ViaticoStatus = "pendiente" | "aprobado" | "pagado" | "contabilizado"

export interface Viatico {
  id: string
  description: string
  provinces: string[]
  departureDate?: string
  returnDate?: string
  requestedAmount: number
  depositDate?: string
  period?: string
  attendees?: string
  workerName: string
  workerDocument?: string
  totalAmount: number
  currency: string
  status: ViaticoStatus
  createdBy: string
  approvedBy?: string
  paidBy?: string
  accountedBy?: string
  accountedAt?: string
  movilizacion: ViaticoItem[]
  alimentacion: ViaticoItem[]
  hospedaje: ViaticoItem[]
  varios: ViaticoItem[]
  accounting: Partial<Record<ViaticoSection, ViaticoSectionAccounting>>
  travelTicketUrl?: string
  createdAt: string
  updatedAt: string
}

export interface CreateViaticoDto {
  description: string
  provinces: string[]
  departureDate?: string
  returnDate?: string
  requestedAmount: number
  depositDate?: string
  period?: string
  attendees?: string
  workerName: string
  workerDocument?: string
  currency?: string
  createdBy: string
}
